import { createAnalyticsEvent } from 'analytics/create-analytics-event';
import { GAEventName } from 'analytics/ga-event-name.enum';
import { StoreEnum } from 'schema/storeCode';
import { CartStatus, CheckoutType, EcommerceItem } from './types';

export const sendViewItemListEvent = createAnalyticsEvent<{
  checkoutType: CheckoutType;
  ecommerce: {
    affiliation?: string;
    item_list_id?: string;
    item_list_name?: string;
    items: EcommerceItem[];
  };
}>(({ checkoutType, ecommerce }) => ({
  event: GAEventName.VIEW_ITEM_LIST,
  checkout_type: checkoutType,
  ecommerce
}));

export const sendAddToCartEvent = createAnalyticsEvent<{
  checkoutType: CheckoutType;
  eventId?: string;
  cartStatus: CartStatus;
  store: StoreEnum;
  ecommerce: {
    affiliation?: string;
    item_list_id?: string;
    item_list_name?: string;
    items: EcommerceItem[];
    currency?: string;
    value?: string;
  };
  user?: {
    email?: string;
  }
}>(({ checkoutType, eventId, cartStatus, ecommerce, store, user }) => ({
  event: GAEventName.ADD_TO_CART,
  event_id: eventId,
  checkout_type: checkoutType,
  cart_status: cartStatus,
  ecommerce,
  store,
  user
}));

export const sendViewCartEvent = createAnalyticsEvent<{
  checkoutType: CheckoutType;
  cartStatus: CartStatus;
  ecommerce?: {
    currency: string;
    cart_value?: string;
    items: EcommerceItem[];
  };
}>(({ checkoutType, cartStatus, ecommerce }) => ({
  event: GAEventName.VIEW_CART,
  checkout_type: checkoutType,
  cart_status: cartStatus,
  ecommerce
}));

export const sendRemoveFromCartEvent = createAnalyticsEvent<{
  checkoutType: CheckoutType;
  ecommerce: {
    currency: string;
    items: EcommerceItem[];
  };
}>(({ checkoutType, ecommerce }) => ({
  event: GAEventName.REMOVE_FROM_CART,
  checkout_type: checkoutType,
  ecommerce
}));
